<template>
  <div class="container">
    <div class="card card-login mx-auto mt-5">
      <div class="card-header">
        <strong>{{ $t('brand') }}</strong> - {{ $t('authentification.login') }}
      </div>
      <div class="card-body">

        <div v-if="error" class="alert alert-danger" role="alert">
          {{error}}
        </div>

        <form @keyup.enter="login">
          <div class="form-group">
            <label for="email">{{ $t('authentification.email') }}</label>
            <input v-model.trim="email" v-validate="'required'" class="form-control" name="email" id="email" type="email" placeholder="Entrez votre courriel">
            <span class="text-danger" v-if="errors.has('email')">{{ errors.first('email') }}</span>
          </div>
          <div class="form-group">
            <label for="password">{{ $t('authentification.password') }}</label>
            <input v-model="password" v-validate="'required'" class="form-control" name="password" id="password" type="password" placeholder="Mot de passe">
            <span class="text-danger" v-if="errors.has('password')">{{ errors.first('password') }}</span>
          </div>
          <div class="form-group">
            <div class="form-check">
              <label class="form-check-label">
                <input v-model="rememberMe" class="form-check-input" type="checkbox"> {{ $t('authentification.keepConnected') }}</label>
            </div>
          </div>
          <a @click="login" href="#" class="btn btn-primary btn-block">{{ $t('authentification.login') }}</a>
        </form>
        <div class="text-center">
          <router-link to="/forgotPassword" class="d-block small mt-3">
            {{ $t('authentification.forgotPassword') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {TokenAuthServiceClient, AuthenticateModel, SessionServiceClient} from '../shared/service-clients/service-clients'
import ServiceFactory from '../shared/service-clients/serviceClientFactory'
import CrudMixin from '../shared/Mixin/CrudMixin'

export default {
  name: 'login',
  mixins: [CrudMixin],
  data() {
    return {
      email: '',
      password: '',
      rememberMe: true,
      error: '',
    }
  },
  methods: {
    login: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          var tokenAuthService = ServiceFactory.create(TokenAuthServiceClient)

          tokenAuthService
            .authenticate(
              new AuthenticateModel({
                userNameOrEmailAddress: this.email,
                password: this.password,
                rememberClient: this.rememberMe,
              })
            )
            .then(res => {
              res.rememberClient = this.rememberMe
              this.$store.commit('login', res)
              this.$router.push('dashboard')
            })
            .catch(err => {
              this.processError(err, this, this.$i18n.t('authentification.errors.loginFailed'))
            })
        }
      })
    },
    fetchData: function() {},
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue